import { createFileRoute, redirect } from "@tanstack/react-router";
import { authClient } from "../lib/authClient";

export const Route = createFileRoute("/")({
  component: Index,
  beforeLoad: async () => {
    const session = await authClient.getSession();
    if (!session?.data) {
      throw redirect({ to: "/login", replace: true, statusCode: 307 });
    } else {
      throw redirect({ to: "/app", replace: true, statusCode: 307 });
    }
  },
});

function Index() {
  return null;
}
